<template>
  <span>
      <el-button type="success"
                 @click="visible=true"
                 size="mini">
          校准
      </el-button>
    <el-dialog
        title="校准打印设备"
        :visible.sync="visible"
        width="400px"
        center>
      <el-form ref="elForm" :model="formData" :rules="rules" size="medium" label-width="100px">
        <el-form-item label="宽" prop="w">
          <el-input-number v-model="formData.w" placeholder="宽" :step='1' controls-position=right :min='1'>
          </el-input-number>
        </el-form-item>
        <el-form-item label="高" prop="h">
          <el-input-number v-model="formData.h" placeholder="高" :step='1' controls-position=right :min='1'>
          </el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="close">取消</el-button>
        <el-button type="primary" @click="handelConfirm">确定</el-button>
      </div>
    </el-dialog>
  </span>
</template>

<script>
export default {
  name: "qrcode-test",
  data: function () {
    return {
      visible: false,
      formData: {
        w: 1,
        h: 1,
      },
      rules: {
        w: [{
          required: true,
          message: '宽',
          trigger: 'blur'
        }],
        h: [{
          required: true,
          message: '高',
          trigger: 'blur'
        }],
      },
    }
  },
  props: {
    printerId: {
      type: String,
      required: true
    },
  },
  methods: {
    onClose() {
      this.$refs['elForm'].resetFields()
    },
    close() {
      this.visible = false
    },
    handelConfirm() {
      let _this = this;
      this.$refs['elForm'].validate(valid => {
        if (!valid) return
        _this.$common.my_ajax({
          url: 'printer/saveCalibrationPrinter',
          data: {
            printerId: _this.printerId,
            w: _this.formData.w,
            h: _this.formData.h,
          },
          success: function () {
            _this.$notify.success("校准成功")
          }
        });
      })
    },
  },
}
</script>

<style scoped>
.box-card {
  margin-top: 20px;
}
</style>